// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    RAW: require('./image_formats/raw'),
    RLE: require('./image_formats/rle'),
    LayerRLE: require('./image_formats/layer_rle'),
    LayerRAW: require('./image_formats/layer_raw')
  };

}).call(this);
